module.exports = __webpack_public_path__ + "img/product-m-bg.359f6f50.png";